module.exports = {"430426001":"洪桥街道","430426002":"玉合街道","430426003":"永昌街道","430426004":"白鹤街道","430426102":"金桥镇","430426103":"鸟江镇","430426104":"粮市镇","430426105":"河洲镇","430426106":"归阳镇","430426107":"过水坪镇","430426108":"双桥镇","430426109":"灵官镇","430426110":"风石堰镇","430426111":"白地市镇","430426112":"黄土铺镇","430426113":"石亭子镇","430426114":"官家嘴镇","430426115":"步云桥镇","430426116":"砖塘镇","430426117":"蒋家桥镇","430426118":"太和堂镇","430426200":"马杜桥乡","430426201":"凤歧坪乡","430426202":"城连圩乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430426.json
// module id = 1966
// module chunks = 0